import React from "react";
import "./styles/Vision.scss";
import TitleFormat from "../../../components/TitleFormat";
import { useTranslation } from "react-i18next";
import { Seo } from "../../../components/Seo";
const Vision = () => {
  const { t } = useTranslation();
  const title = `Mission, Vision & Core Value \n${t("aboutUs.vision.title")}`;
  const contentTitle = t("aboutUs.vision.content.title", { returnObjects: true }) as { text: string; highlight?: string }[];
  const contentMentMain = t("aboutUs.vision.content.ment.main", { returnObjects: true }) as { text: string; highlight?: string }[];
  const contentMentList = t("aboutUs.vision.content.ment.list", { returnObjects: true }) as { text: string; highlight?: string }[][];
  return (
    <>
      <Seo title={`${t("aboutUs.vision.seo.title")}`} description={`${t("aboutUs.vision.seo.des")}`} path="about/vision" />
      <div id="vision_wrap">
        <TitleFormat text={title} />
        <div className="content">
          <div className="environment_wrap">
            <div className="title">
              {contentTitle.map((ment, index) => {
                return (
                  <span className={ment.highlight} key={`${ment.text}_${index}`}>
                    {ment.text}
                  </span>
                );
              })}
            </div>
            <div className="text_wrap">
              <div className="main_text">
                {contentMentMain.map((ment, index) => {
                  return (
                    <span className={ment.highlight} key={`${ment.text}_${index}`}>
                      {ment.text}
                    </span>
                  );
                })}
              </div>
              <ul>
                {contentMentList.map((list, index) => {
                  return (
                    <li key={`contentMentList_${index}`}>
                      {list.map((ment, index2) => {
                        return (
                          <span className={ment.highlight} key={`${ment.text}_${index2}`}>
                            {ment.text}
                          </span>
                        );
                      })}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
          <div className="img_box">
            <img src="/imgs/aboutus_vision.png" alt="" />
          </div>
          <div className="net_zero_wrap">
            <div className="title">{t("aboutUs.vision.content.netZero.title")}</div>
            <div className="text_wrap">
              <div className="main_text">{t("aboutUs.vision.content.netZero.mainText")}</div>
              <div className="sub_text">{t("aboutUs.vision.content.netZero.subText")}</div>
              <div className="sub_text">{t("aboutUs.vision.content.netZero.subText2")}</div>
            </div>
          </div>
          <div className="vision_wrap">
            <div className="title">{t("aboutUs.vision.content.vision.title")}</div>
            <div className="text_wrap">
              <div className="main_text">{t("aboutUs.vision.content.vision.mainText")}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Vision;
